export const dateFormatRegex = /^\d{4}-\d{1,2}-\d{1,2}$/;
export const invalidAmountRegex = /^[eE+-]/;
export const invalidTreatAmountRegex = /^[eE+-]/;
export const invalidFillingCountRegex = /^[eE+-.,]/;
export const onlyDigitRegex = /^\d+$/;
export const whitespaceRegex = /\s+/g;
